const timeFormatter = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
  timeStyle: "short",
});

export function formatTime(value?: string): string {
  if (!value) {
    return "—";
  }

  return timeFormatter.format(new Date(value));
}
